import { AddServiceToRealmModal } from 'RealmModule/components/SubscriptionRealm/AddServiceToRealmModal';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ComponentProps, useCallback } from 'react';

export const useAddServiceToRealmModal = () => {
  const { openModal } = useDynamicModal();

  const openAddServiceToRealmModal = useCallback(
    (args: Omit<ComponentProps<typeof AddServiceToRealmModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <AddServiceToRealmModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );
  return {
    openAddServiceToRealmModal,
  };
};
